import { formatDate } from "utils/date";

export const defaultFilename = (type, subtype = "") =>
  `export_${subtype}${formatDate(new Date(), "YYY-MM-DD_HH-mm")}.${type === "excel" ? "xlsx" : "docx"}`;
